// extracted by mini-css-extract-plugin
export default {"overlay":"IconTooltip_overlay__Ep2TV","iconText":"IconTooltip_iconText__4k572"};